import { expVal } from '@townsquare/stat-sig';
import { experiments } from '@townsquare/stat-sig/experiments';

export const useIsNotificationsSidebarEntryRemoved = (): boolean =>
	expVal(experiments.TOWNSQUARE_NOTIFICATIONS_REMOVE_SIDEBAR_ENTRY_EXP, 'cohort', 'control') ===
	'test';
